<template>
  <div class="headBox" ref="headBox" :style="'top:'+topNum+'px;'">
    <!--  -->
    <div class="headBox_cont" v-if="routerInfo.path == '/'">
      <img src="@/assets/img/h_1.png" class="headBox_1" alt="">
      <img src="@/assets/img/h_2.png" class="headBox_2" alt="">
    </div>

    <div class="headBox_cont" v-if="routerInfo.path == '/eliminationList'">
      <img src="@/assets/img/h_3.png" class="headBox_1" alt="">
      <div class="headBox_3" v-if="listIndex != 0"></div>
      <div class="headBox_4" v-if="routerInfo.path == '/eliminationList'">汰汰清单</div>
    </div>

    <div class="headBox_cont" v-if="routerInfo.path == '/orderPrinting'">
      <img src="@/assets/img/h_3.png" class="headBox_1" alt="">
      <div class="headBox_3" v-if="listIndex != 0"></div>
      <div class="headBox_4" v-if="routerInfo.path == '/orderPrinting'">店星人</div>
    </div>

    <div class="headBox_cont" v-if="routerInfo.path == '/downloadApp'">
      <img src="@/assets/img/h_3.png" class="headBox_1" alt="">
      <div class="headBox_3"></div>
      <div class="headBox_4 headBox_5" @click="returnUp">返回首页 </div>
    </div>

    <div :class="['headBox_cont',isShow == false ? '' : 'headBox_cont_2']"
      v-if="routerInfo.path == '/eliminationListDetails'">
      <img src="@/assets/img/h_3.png" :class="['headBox_1',isShow == false ? '' : 'headBox_9']" alt="">
      <div class="headBox_3"></div>
      <div :class="['headBox_4', 'headBox_5',isShow == false ? '' : 'headBox_8']" @click="returnUp">返回首页 </div>
    </div>

    <div :class="['headBox_cont',isShow == false ? '' : 'headBox_cont_2']"
      v-if="routerInfo.path == '/orderPrintingDetails'">
      <img src="@/assets/img/h_3.png" :class="['headBox_1',isShow == false ? '' : 'headBox_9']" alt="">
      <div class="headBox_3"></div>
      <div :class="['headBox_4', 'headBox_5',isShow == false ? '' : 'headBox_8']" @click="returnUp">返回首页 </div>
    </div>

    <div :class="['headBox_cont',isShow == false ? '' : 'headBox_cont_2']" v-if="routerInfo.path == '/companyDetails'">
      <img src="@/assets/img/h_1.png" class="headBox_1" alt="" v-if="isShow == false">
      <img src="@/assets/img/h_3.png" :class="['headBox_1',isShow == false ? '' : 'headBox_9']" alt=""
        v-if="isShow == true">
      <div :class="['headBox_3',isShow == false ? 'headBox_6' : '']"></div>
      <div :class="['headBox_4', 'headBox_5',isShow == false ? 'headBox_7' : 'headBox_8']" @click="returnUp">返回首页 </div>
    </div>
  </div>
</template>
<script>
  /**
   * Created by www.xingnuocn.com
   * @title：公用头部
   * @author: 刘嘉鑫
   */
  export default {
    inject: ["reload"], // 刷新页面
    data() {
      return {
        routerInfo: "",
        listIndex: 0,
        routerFrom: "",
        isShow: false,
        topNum: 0,
      };
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScrollbox, true);
    },
    mounted() {
      window.addEventListener("scroll", this.handleScrollbox, true);
      // console.log(this.$route)
    },
    watch: {
      // 利用watch方法检测路由变化：
      $route: function (to, from) {
        console.log("tototo", to)
        console.log("fromfromfrom", from)
        this.routerInfo = to
        this.listIndex = to.meta.index;
        this.routerFrom = from
      },
    },
    methods: {
      // 返回首页
      returnUp() {
        if (this.routerFrom.path == "/eliminationListDetails") {
          this.$router.go(-2)
        } else {
          this.$router.go(-1)
        }
      },

      handleScrollbox() {
        this.currentScroll = window.pageYOffset; //表示当前滚动的位置
        if (this.currentScroll >= 67) {
          this.isShow = true
          this.$(".headBox").addClass(" fixed-header");
        } else {
          this.isShow = false
          this.$(".headBox").removeClass(" fixed-header");
        }

        this.topNum = this.currentScroll / 10 < 58 ? this.currentScroll / 10 : 58
      },
    },
  };
</script>
<style lang='scss' scoped>
  .headBox {
    position: absolute;
    width: 100%;
    z-index: 9999;


    .headBox_cont {
      display: flex;
      align-items: center;
      padding: 40px 38px 20px;
    }

    .headBox_1 {
      width: 148px;
      height: 28px;
    }

    .headBox_2 {
      width: 145px;
      height: 14px;
      margin-left: auto;
    }

    .headBox_3 {
      width: 1px;
      height: 20px;
      background: #5D6574;
      margin: 0 10px;
    }

    .headBox_4 {
      font-weight: 400;
      font-size: 21px;
      color: #333A47;
      letter-spacing: 2px;
    }

    .headBox_5 {
      cursor: pointer;
    }

    .headBox_6 {
      background: #ffffff;
    }

    .headBox_7 {
      color: #ffffff;
    }

    .headBox_8 {
      font-size: 19px !important;
    }

    .headBox_9 {
      width: 120px;
      height: 23px;
    }
  }

  .headBox_cont_2 {
    padding: 24px 38px 16px !important;
  }

  .fixed-header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
    border-bottom: 1px solid rgba(18, 20, 28, 0.04);
    -webkit-backdrop-filter: saturate(180%) blur(6px);
    backdrop-filter: saturate(180%) blur(6px);
    background: rgba(255, 255, 255, 0.8);
  }
</style>